import { useCallback, useContext } from 'react';
import { MediaPlayerDispatchContext } from '../context/media-player-context';
import { MediaPlayerActionKind } from '../types/media-player-action';

export const useSetCurrentEpisodeId = () => {
  const { dispatch } = useContext(MediaPlayerDispatchContext);
  return useCallback((episodeId: string) => {
    dispatch({type: MediaPlayerActionKind.SET_EPISODE_ID, payload: episodeId});
  }, [ dispatch ])
}